module.exports = __webpack_public_path__ + "img/12_56.872f397d.png";